import { VERTICAL_STYLE, CALL_STYLE, STATUS_STYLE } from "@/lib/api";

export const Sel = ({ value, onChange, options, placeholder, testid, className = "" }) => (
  <select data-testid={testid} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className={`crm-input pr-8 ${className}`}>
    {placeholder !== undefined && <option value="">{placeholder}</option>}
    {options.map((o) => (typeof o === "string"
      ? <option key={o} value={o}>{o}</option>
      : <option key={o.value} value={o.value}>{o.label}</option>))}
  </select>
);

export const Field = ({ label, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="crm-label">{label}</span>
    {children}
  </label>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const Pill = ({ children, className = "" }) => (
  <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${className}`}>{children}</span>
);
export const VerticalBadge = ({ v }) => <Pill className={`border ${VERTICAL_STYLE[v] || "bg-slate-100"}`}>{v}</Pill>;
export const CallBadge = ({ s }) => <Pill className={CALL_STYLE[s] || "bg-slate-100 text-slate-700"}>{s}</Pill>;
export const StatusBadge = ({ s }) => <Pill className={STATUS_STYLE[s] || "bg-slate-100 text-slate-700"}>{s}</Pill>;
export const StageBadge = ({ s }) => (
  <Pill className={s === "Won" ? "bg-emerald-100 text-emerald-800" : s === "Lost" ? "bg-rose-100 text-rose-800" : "bg-slate-100 text-slate-700"}>{s}</Pill>
);

export const Kpi = ({ label, value, sub, icon: Icon, tone = "slate", testid }) => {
  const tones = { slate: "text-slate-400", brand: "text-primary", green: "text-[hsl(var(--brand-accent))]",
    red: "text-rose-500", blue: "text-primary", amber: "text-primary", violet: "text-primary" };
  return (
    <div className="crm-card fade-up p-4 transition-colors hover:border-[hsl(var(--brand-accent))]" data-testid={testid}>
      <div className="flex items-start justify-between">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{label}</p>
        {Icon && <Icon className={`h-4 w-4 ${tones[tone]}`} />}
      </div>
      <p className="num mt-2 text-2xl font-bold text-[hsl(var(--charcoal))]">{value}</p>
      {sub && <p className="mt-0.5 text-xs text-muted-foreground">{sub}</p>}
    </div>
  );
};

export const Empty = ({ text = "Nothing here yet" }) => (
  <div className="py-12 text-center text-sm text-muted-foreground" data-testid="empty-state">{text}</div>
);

export const Section = ({ title, action, children, className = "" }) => (
  <div className={`crm-card ${className}`}>
    {title && (
      <div className="flex items-center justify-between border-b px-4 py-3">
        <h3 className="text-sm font-bold text-slate-800">{title}</h3>
        {action}
      </div>
    )}
    {children}
  </div>
);

export const Tabs = ({ tabs, value, onChange, testid = "tabs" }) => (
  <div className="mb-4 flex gap-1 overflow-x-auto border-b scroll-thin" data-testid={testid}>
    {tabs.map((t) => {
      const v = typeof t === "string" ? t : t.value;
      const l = typeof t === "string" ? t : t.label;
      return (
        <button key={v} data-testid={`${testid}-${v}`} onClick={() => onChange(v)}
          className={`-mb-px whitespace-nowrap border-b-2 px-3 py-2 text-sm font-semibold transition-colors ${value === v ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-slate-800"}`}>
          {l}
        </button>
      );
    })}
  </div>
);
